import React from 'react'
import Main from './components/Main'
import { AuthProvider } from './context/auth'
import { IntegrationProvider } from './context/integration'
import { CallProvider } from './context/call/CallProvider'
import { EeoProvider } from './context/eeo'
import { ModalProvider } from './context/modal'
import { CountriesProvider } from './context/countries'
import { LanguageProvider } from './context/languages'
import { PageLeaveProvider } from './context/pageLeave'
import { CustomFieldsProvider } from './context/customFields'
import { BrandProvider } from './context/brand'
import { ChannelProvider } from './context/channel'

function App() {
	return (
		<ModalProvider>
			<PageLeaveProvider>
				<CustomFieldsProvider>
					<BrandProvider>
						<AuthProvider>
							<ChannelProvider>
								<IntegrationProvider>
									<EeoProvider>
										<CountriesProvider>
											<LanguageProvider>
												<CallProvider>
													<Main />
												</CallProvider>
											</LanguageProvider>
										</CountriesProvider>
									</EeoProvider>
								</IntegrationProvider>
							</ChannelProvider>
						</AuthProvider>
					</BrandProvider>
				</CustomFieldsProvider>
			</PageLeaveProvider>
		</ModalProvider>
	)
}

export default App
